<template>
    <div class="px-3 py-2 bg-light grid grid-cols-1 gap-y-3" :class="width">
        <div v-for="row in rows">
            <p class="text-primary-dark text-base !mb-0">{{ fields[row.field_id]?.fac_search_name ?? '' }}:</p>
            <div class="text-primary-dark text-base font-bold" v-html="store.data.fac_type_memberships.mappedAnswer(fields[row.field_id], row.answer)" />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@app/fac-search/state/store'

    const props = defineProps({
        member: Object,
        width: {
            type    : String,
            default : 'w-56'
        },
    })

    const fields = computed(() => store.data.fac_type.fields.value)
    const rows = computed(() => store.memberFieldsForSection('details-card', props.member) ?? [])
</script>